import type { QueryToUrlTransformer } from '@atlassian/jira-common-query-param-adapter/src/model/index.tsx';
import type { Query } from '../model/index.tsx';

export const queryToUrl: QueryToUrlTransformer<Query> = (query) => {
	if (query) {
		const { filter, orderDirection, orderField, page } = query;
		return {
			filter,
			orderDirection,
			orderField,
			page,
		};
	}
	return {};
};
